@if (schedule) {
  <div class="schedule-details">
    <div class="schedule-details__table-scroll">
    <table mat-table [dataSource]="schedule.payments" [trackBy]="trackByPaymentId"
      class="schedule-details__table"
      [class.schedule-details__table--with-fees]="schedule.showFees"
      [attr.aria-labelledby]="ariaLabelledBy">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef
          class="grid-column-multiline">Date</th>
        <td mat-cell *matCellDef="let payment"
          class="grid-column-multiline">
          <div class="schedule-details__date">
            @if (isClickable(payment)) {
              <!-- The row's keyboard / assistive-tech affordance: a pointer press lands anywhere
              on the row (pointerdown on the tr). A tabindex or role on the tr would add a
              nameless tab stop and break the table's row semantics (see to-table). -->
              <button type="button" class="schedule-details__row-action"
                (click)="onClick_rowAction(payment, $event)">{{ payment.date
                  | scheduledDate }}</button>
            } @else {
              {{ payment.date | scheduledDate }}
            }
          </div>
          @if (payment.status) {
            <div
              class="schedule-details__status">
              {{ payment.status | sentencecase }}
            </div>
          }
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>Totals</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let payment"
          [attr.data-amount-marker]="payment.amountMarker || null">{{ payment.amount
            | currency:'USD':'symbol':'1.2-2' }}</td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{ schedule.totalScheduledAmount | currency:'USD':'symbol':'1.2-2' }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="fee">
        <th mat-header-cell *matHeaderCellDef>Fee<!-- TODO (TOP-3034): Restore when estimate display is configurable: {{ schedule.feesAreEstimates ? ' *' : '' }} --></th>
        <td mat-cell *matCellDef="let payment">{{ (payment.fee ?? 0) | currency:'USD':'symbol':'1.2-2' }}</td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{ (schedule.totalFees ?? 0) | currency:'USD':'symbol':'1.2-2' }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let payment">{{ (payment.total ?? payment.amount) | currency:'USD':'symbol':'1.2-2' }}</td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{ (schedule.grandTotal ?? schedule.totalScheduledAmount) | currency:'USD':'symbol':'1.2-2' }}</strong>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let payment; columns: displayedColumns;"
        [class.pending-row]="isPendingPayment(payment)"
        [class.selected-row]="isSelectedPayment(payment)"
        [class.clickable-row]="isClickable(payment)"
        [attr.aria-current]="isSelectedPayment(payment) ? 'true' : null"
        (pointerdown)="onPointerdown_row(payment, $event)"></tr>
      <tr mat-footer-row
        *matFooterRowDef="displayedColumns"></tr>
    </table>
    </div>
    @if (hasAdjustedFinalPayment) {
      <p class="schedule-details__footnote">
        ** Final payment adjusted to match the remaining
        balance.
      </p>
    }
    <!-- TODO (TOP-3034): Restore when estimate display is configurable
    @if (schedule.feesAreEstimates) {
      <p class="schedule-details__footnote">
        * Fees are estimates and may vary slightly at time of
        processing.
      </p>
    }
    -->
    @if (schedule.originalBalanceDue !== undefined && schedule.originalBalanceDue !== null) {
      <mat-list>
        <mat-list-item>
          <div mat-line class="schedule-details__summary-row">
            <strong>Total Amount Scheduled:</strong>
            <span>{{ schedule.totalScheduledAmount | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        </mat-list-item>
        <mat-list-item>
          <div mat-line class="schedule-details__summary-row">
            <strong>Balance Due (at time of scheduling):</strong>
            <span>{{ schedule.originalBalanceDue | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        </mat-list-item>
        <mat-list-item>
          <div mat-line class="schedule-details__summary-row">
            <strong>Total Amount Paid:</strong>
            <span>{{ schedule.totalAmountPaid | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        </mat-list-item>
        <mat-list-item>
          <div mat-line class="schedule-details__summary-row">
            <strong>Balance Remaining:</strong>
            <span>{{ schedule.balanceRemaining | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        </mat-list-item>
      </mat-list>
    }
  </div>
}
